import React from 'react'
import Footer from '../Footer'
import HomeFun from '../HomeFun'

function Resources() {
  return (
    <div>
      <HomeFun/>
      <Footer/>
    </div>
  )
}

export default Resources
